export default "__VITE_ASSET__Cjywe5Z2__"